import { cn } from '@/libs/utils/cn';

/**
 * HubSpot's sprocket — the ring and its three spoked nodes. It marks the card's create action as
 * handing the location to the portal rather than to SpotOn.
 *
 * Drawn rather than shipped as the brand's raster so it inherits `currentColor`: it sits on the
 * app's dark primary button, where HubSpot's own orange would clash.
 */
export function HubSpotMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      focusable="false"
      className={cn('shrink-0', className)}
    >
      <circle cx="14.6" cy="14.6" r="4.6" stroke="currentColor" strokeWidth="3.2" />
      <circle cx="14.6" cy="3.3" r="2.7" fill="currentColor" />
      <circle cx="3.3" cy="3.3" r="2.7" fill="currentColor" />
      <circle cx="4.2" cy="20.7" r="2.7" fill="currentColor" />
      <path
        d="M14.6 6v2.7M5.3 5.3l5.2 5.2M6.4 19.4l4.1-2.4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
